import { render, staticRenderFns } from "./MonthBlocks.vue?vue&type=template&id=4a5e128a"
import script from "./MonthBlocks.vue?vue&type=script&lang=js"
export * from "./MonthBlocks.vue?vue&type=script&lang=js"
import style0 from "./MonthBlocks.vue?vue&type=style&index=0&id=4a5e128a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports